import type { IconDefinition } from '../index.tsx';

export const iconGallery: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconGallery',
  icon: [
    16,
    16,
    [],
    '',
    'M5.50428 1.78155C6.179 1.4067 7.02866 1.63161 7.4035 2.28134L11.5768 9.52839C11.9766 10.1781 11.7517 11.0278 11.077 11.4276L6.25397 14.2015C5.57925 14.5763 4.7296 14.3514 4.35475 13.7017L0.18145 6.45464C-0.193397 5.80491 0.0315114 4.95525 0.681246 4.55542L5.50428 1.78155ZM12.2765 9.12855L8.85291 3.20597C8.90289 3.20597 8.95287 3.18098 9.00285 3.18098H14.6006C15.3503 3.18098 16 3.83071 16 4.58041V12.977C16 13.7517 15.3503 14.3764 14.6006 14.3764H9.00285C8.653 14.3764 8.32813 14.2765 8.10322 14.0515L11.4768 12.1023C12.5264 11.5026 12.8763 10.1781 12.2765 9.12855Z',
  ],
};
